import { GenreCategoryOut } from '../../../../../store/apiLibx';
import { ObjectTypeWithAll } from '../../../../../api/local-content/collection/product/types';
import { TFunction } from 'i18next';

export const mapGenreCategory = (
    genreCategory: ObjectTypeWithAll | GenreCategoryOut | undefined,
    categories: GenreCategoryOut | undefined,
    t: TFunction
) => {
    if (typeof genreCategory === 'object' && genreCategory !== null) {
        if ('current' in genreCategory) {
            const genreCategoryName = genreCategory.current;
            const genreCategoryId = genreCategory ? genreCategory.currentKey : '';
            const genreCategoryData: ObjectTypeWithAll = {
                current: t(`filters:genre.${genreCategoryId}`, genreCategoryName || ''),
                currentKey: genreCategoryId ?? '',
                all: categories || {}
            };

            return genreCategoryData;
        } else {
            const genreCategoryName = genreCategory?.name;
            const genreCategoryId = genreCategory ? genreCategory.id : '';
            const genreCategoryData: ObjectTypeWithAll = {
                current: t(`filters:genre.${genreCategoryId}`, genreCategoryName || ''),
                currentKey: genreCategoryId ?? '',
                all: categories || {}
            };

            return genreCategoryData;
        }
    } else {
        return {
            current: t('yourLocalContent.yourTitles.select'),
            currentKey: '',
            all: categories || {}
        };
    }
};
